import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

const inputCls = "w-full bg-[#0D1117] border border-[#263342] px-4 py-3 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-crimson transition-colors";
const labelCls = "block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2";

export default function SettingsPanel() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed", { description: "Use your new password next time you log in." });
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error("Could not change password", { description: formatApiError(err) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md" data-testid="settings-panel">
      <h2 className="font-display font-bold uppercase tracking-tight text-2xl text-slate-100">Settings</h2>
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-1 mb-8">Admin account security</p>

      <div className="bg-[#0D1117] border border-[#263342] p-6">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-9 h-9 bg-crimson/15 border border-crimson/50 flex items-center justify-center">
            <KeyRound size={16} className="text-crimson" />
          </span>
          <h3 className="font-display font-bold uppercase tracking-tight text-lg text-slate-100">Change Password</h3>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <div>
            <label className={labelCls}>Current password</label>
            <input type="password" required className={inputCls} data-testid="current-password-input" value={current} onChange={(e) => setCurrent(e.target.value)} />
          </div>
          <div>
            <label className={labelCls}>New password (min 6 characters)</label>
            <input type="password" required minLength={6} className={inputCls} data-testid="new-password-input" value={next} onChange={(e) => setNext(e.target.value)} />
          </div>
          <div>
            <label className={labelCls}>Confirm new password</label>
            <input type="password" required minLength={6} className={inputCls} data-testid="confirm-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <button type="submit" data-testid="change-password-submit" disabled={saving} className="w-full bg-crimson text-white font-display font-semibold uppercase tracking-widest py-3.5 disabled:opacity-60">
            {saving ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
